/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import * as OnboardingActions from 'actions/OnboardingActions';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as SourceConstants from 'constants/SourceConstants';

const {PROJECT_TYPE} = SourceConstants;

import * as tour from 'help/Tour';
import NavStore from 'nav/NavStore';
import {NavTutorialForNewUsers} from 'nav/NavTutorial';
import notifications from 'notifications';
import EntityStore from 'stores/EntityStore';
import * as analytics from 'analytics/Analytics';
import CreateSourceModal from 'create-components/CreateSourceModal';
import legacyRunModal from 'ui-library/legacyRunModal';

// Track last opened ELN tutorial `TourView`
let tourView = null;

export function runTutorial() {
  analytics.track('onboarding_tour', 'started', {
    tour: 'navigation',
    tourOrigin: 'checklist_sidepanel',
    numberOfSteps: 6,
    eventLastModified: 'FY21_Q1a2',
  });
  if (tourView != null) {
    // Kill existing (last opened) tour if it exists, before creating a new one
    tourView.kill(false);
  }
  const currentUser = EntityStore.currentUser();
  if (currentUser == null) {
    return;
  }
  const project = _.findWhere(NavStore.getSources(), {sourceType: PROJECT_TYPE});
  if (project != null) {
    const tutorial = NavTutorialForNewUsers;
    tourView = new tour.TourView({
      collection: new tour.Tour(tutorial),
      onFinish() {
        analytics.track('onboarding_tour', 'completed', {
          tour: 'navigation',
          tourOrigin: 'checklist_sidepanel',
          numberOfSteps: 6,
          eventLastModified: 'FY21_Q1a2',
        });
        OnboardingActions.completeOnboardingTask(
          OnboardingConstants.MODULES.GETTING_STARTED,
          OnboardingConstants.MAIN_TOUR
        );
      },
    });
    tourView.next();
  } else {
    notifications.warn('Create a project and then reopen the tutorial.');
    legacyRunModal(CreateSourceModal, {});
  }
}
